

export class IdFournisseurRatioModel {

  idFournisseur: number;
  ratio: number;
}
